import { useAuthStore } from '@/features/auth/stores/auth.store'
import { getDashboardPathForRole, getRoleLabel } from '@/shared/constants/roles'

export function useAuth() {
  const user = useAuthStore((state) => state.user)
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isBootstrapping = useAuthStore((state) => state.isBootstrapping)
  const isLoading = useAuthStore((state) => state.isLoading)
  const error = useAuthStore((state) => state.error)
  const sendOtp = useAuthStore((state) => state.sendOtp)
  const login = useAuthStore((state) => state.login)
  const logout = useAuthStore((state) => state.logout)
  const clearError = useAuthStore((state) => state.clearError)
  const bootstrap = useAuthStore((state) => state.bootstrap)

  return {
    user,
    isAuthenticated,
    isBootstrapping,
    isLoading,
    error,
    sendOtp,
    login,
    logout,
    clearError,
    bootstrap,
    role: user?.role ?? null,
    dashboardPath: user?.role ? getDashboardPathForRole(user.role) : null,
    roleLabel: user?.role ? getRoleLabel(user.role) : null,
  }
}
